module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAPZJREFUWIXtlkGKgzAUhr+U4hHqJVy6j55u2nPFrGY5Z1DwFG8WoyWUaMeE11rwgx9Eie8zL2rgYEcUwA0YAFnJN3DRELg+KRzmR0OiB8R7L0uM4yhVValJCLBYfEFia3r+ZrpIFpgl6rpOlZBJIl0gFedcOBMAmAcBROTfPUvBmHtJA3BSrbYRAaQsy5zerubh3kCkBS8k3gLvPSKiEudc3GLi8xahtRZrbZ5QcLx5BuanSRnDXl7DzxKw1mKMuWcmPNe2rZ6ABscifLvAOWdw0zTZArv6FA8AXdepFQ9+RkPs+pZteW6+YgLFJNErFl7dFR+8hV8zy8bRV9gErgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add-project-group.png
// module id = 2683
// module chunks = 0